


























import { Component, Vue, Prop } from 'vue-property-decorator';

import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import OutlinedButton from '@/components/molecules/OutlinedButton/OutlinedButton.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import { treatUrl } from '@/utils/treatUrl';

@Component({
  components: {
    TextInput,
    FlexButton,
    OutlinedButton,
    FilledButton
  }
})
export default class ShopifyTooltip extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: 'Shopify' }) providerName!: string;
  error = false;
  url = '';

  get tPrefix() {
    return 'common.components.businessProvider';
  }

  updateValue(value: string) {
    this.error = false;
    this.url = value;
  }

  cancel() {
    this.$ga.event({
      eventCategory: 'integrations',
      eventAction: 'click-cancel',
      eventLabel: 'What is your Shopify URL?'
    });

    this.$emit('cancel');

    setTimeout(() => {
      this.error = false;
      this.url = '';
    }, 300);
  }

  confirm() {
    this.$ga.event({
      eventCategory: 'integrations',
      eventAction: 'click-confirm',
      eventLabel: String(
        this.$t(`${this.tPrefix}.providerModalTitle`, {
          provider: this.providerName
        })
      )
    });

    if (this.url) {
      const url = treatUrl(this.url);
      this.$emit('confirm', url);
    } else {
      this.error = true;
    }
  }
}
